/**
 * @author wxw
 * 模块说明：院系、年级、学年学期
 */

import { Service } from '@/tools'
export class GradeService<T extends TOrder.Grade> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Grade}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  private get2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Grade}`, data?: TCommon.Json, toast?: string) {
    return this.get(url, data, toast)
  }

  /**
   * 功能：查询院系、年级、学年学期下拉框
   * type	类型 0 院系，1年级，2学年学期
   * /api/order/grade/v1/gradeDropDown
   */
  gradeDropDown = <K extends T['ApiGradeDropDown']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGradeDropDown', data)

  /**
   * 功能：新增年级
   * 0 院系，1年级，2学年学期
   * /api/order/grade/v1/addGrade
   */
  addGrade = <K extends T['ApiAddGrade']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddGrade', data, '新增成功')

  /**
   * 功能：新增年级
   * 0 院系，1年级，2学年学期
   * /api/order/grade/v1/updateGrade
   */
  updateGrade = <K extends T['ApiUpdateGrade']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateGrade', data, '更新成功')

  /**
   * 功能：新增年级
   * 0 院系，1年级，2学年学期
   * /api/order/grade/v1/gradePage
   */
  gradePage = <K extends T['ApiGradePage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGradePage', data)
  /**
   * 功能：查询年级详情
   * /api/order/grade/v1/gradeDetail
   */
  gradeDetail = <K extends T['ApiGradeDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGradeDetail', data)

  /**
   * 功能：分批查询学生数列表
   * /api/order/grade/v1/gradeDetail
   */
  studentNumPage = <K extends T['ApiStudentNumPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiStudentNumPage', data)

  /**
   * 功能: 新增学生数
   * /api/order/grade/v1/addStudentNum
   */
  addStudentNum = <K extends T['ApiAddStudentNum']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddStudentNum', data, '新增成功')

  /**
   * 功能: 新增学生数
   * /api/order/grade/v1/deleteStudentNum
   */
  deleteStudentNum = <K extends T['ApiDeleteStudentNum']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteStudentNum', data, '删除成功')

  /**
   * 功能：修改学生数
   * /api/order/grade/v1/updateStudentNum
   */
  updateStudentNum = <K extends T['ApiDeleteStudentNum']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateStudentNum', data, '修改成功')
}
